import { render, staticRenderFns } from "./loginPopup.vue?vue&type=template&id=5e671d3b&"
import script from "./loginPopup.vue?vue&type=script&lang=js&"
export * from "./loginPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports